import component from './en-US/component';
import common from './en-US/common';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import analytics from './en-US/analytics';
import salescard from './en-US/salescard';
import analysisOthers from './en-US/analysisOthers';
import mission from './en-US/mission';
import miner from './en-US/miner';
import user_management from './en-US/user_management';
import leaderboard from './en-US/leaderboard';
import translation from './en-US/translation';
import wallet from './en-US/wallet';
import dashboard from './en-US/dashboard';
import notification from './en-US/notification';
import notificationViVN from './vi-VN/notification';

const localLocales = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('app_translations') || '{}') : {};

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...common,
  ...pages,
  ...salescard,
  ...analytics,
  ...analysisOthers,
  ...mission,
  ...miner,
  ...user_management,
  ...leaderboard,
  ...translation,
  ...wallet,
  ...dashboard,
  ...notification,
  ...(localLocales.en || {})
};
